import styled from "styled-components";

/**
 * Shared shell for the right-column cards on the confirmed RSVP status page
 * ("Your Ticket" and "Your Share Graphic")
 */
export const SideCard = styled.div`
  width: 100%;
  padding: 24px;
  border: 1px solid ${({ theme }) => theme.globalConstants.color.borderGray};
  border-radius: 16px;
  background: ${({ theme }) => theme.globalConstants.color.white};
`;

export const SideCardLabel = styled.div`
  font-family: ${({ theme }) => theme.globalConstants.fontFamily.heading};
  font-size: 14px;
  font-weight: 900;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.globalConstants.color.textDark};
`;
